import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';

import {UsersListService} from '@app/4dm1n/users-list/users-list.service';
import {RefreshList, RefreshListFailure, RefreshListSuccess} from '@app/4dm1n/users-list/store/organizations/organizations-list.actions';

import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';


@Injectable()
export class OrganizationsListEffects {
  constructor(
    private actions: Actions,
    private store: Store<AppState>,
    private usersListService: UsersListService,
  ) {
  }

  refreshList = createEffect(() => this.actions.pipe(
    ofType(RefreshList),
    map((action) => action),
    switchMap(payload => {
      return this.usersListService.getOrganizationList()
        .pipe(
          map(data => RefreshListSuccess({organizationList: data.data.datas.rows.sort((a, b) => a.name.localeCompare(b.name))})),
          catchError(error =>
            of(RefreshListFailure({error}))
          )
        );
    }),
  ));

}
